var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "custom-class": "success-dialog",
        title: "",
        visible: _vm.isOpen,
        width: "7rem",
        "append-to-body": "",
        "close-on-click-modal": true,
        "show-close": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.isOpen = $event
        },
      },
    },
    [
      _c("div", { staticClass: "sign-success" }, [
        _c("img", {
          attrs: { src: require("../../assets/image/login/success.png") },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "sign-success_title" }, [
          _vm._v(_vm._s(_vm.msg || "Submit completed!")),
        ]),
        _vm._v(" "),
        !_vm.noTip
          ? _c("div", { staticClass: "sign-success_tip" }, [
              _vm._v("Return within " + _vm._s(_vm.count) + " seconds."),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }